module.exports = __webpack_public_path__ + "static/media/igear.6fcbed1f.svg";